import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Loader } from '@altermaind/web/ui';
import { AlertBadge } from '@/_shared/components';
import { getEmployeesStatsCall } from '@/people/state/api';
import { useCurrentTemplate } from '../../state';
import { getSurveysCampaignsCall } from '../../state/api';
import { CampaignsList } from '../CampaignsList';
import { EmptyStateNoCampaigns } from '../EmptyStateNoCampaigns';
import { EmptyStateNoPeople } from '../EmptyStateNoPeople';

export const SurveysIntro = () => {
  const tShared = useTranslations();
  const { isHardSkillSurvey } = useCurrentTemplate();

  const [trigger, setTrigger] = useState(false);
  const { surveyId } = useParams();

  const {
    execute: executeGetEmployeesStats,
    loading: loadingGetEmployeesStats,
    error: errorGetEmployeesStats,
    completed,
  } = getEmployeesStatsCall.hook();

  const {
    execute: executeGetSurveysCampaigns,
    response: responseGetSurveysCampaigns,
    loading: loadingGetSurveysCampaigns,
    error: errorGetSurveysCampaigns,
    success: successGetSurveysCampaigns,
  } = getSurveysCampaignsCall.hook();

  const campaignsForThisSurvey = useMemo(() => {
    return (
      responseGetSurveysCampaigns &&
      responseGetSurveysCampaigns.filter(
        campaign => campaign.surveyTemplateId === surveyId && campaign.invitedUserIds?.length,
      )
    );
  }, [responseGetSurveysCampaigns, surveyId]);

  useEffect(() => {
    executeGetEmployeesStats({
      successSaga: ({ response }) => {
        if (
          response.completed > 0 ||
          (!successGetSurveysCampaigns && !errorGetSurveysCampaigns && !loadingGetSurveysCampaigns)
        ) {
          executeGetSurveysCampaigns({});
        }
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [surveyId]);

  if (!campaignsForThisSurvey && (loadingGetEmployeesStats || loadingGetSurveysCampaigns)) {
    return (
      <Box mt='s' textAlign='center'>
        <Loader size='s' />
      </Box>
    );
  }

  if (errorGetEmployeesStats || errorGetSurveysCampaigns) {
    const message = tShared('errors.genericApiError');
    return <AlertBadge iconName='info' type='error' label={message} />;
  }

  if (campaignsForThisSurvey && !errorGetEmployeesStats) {
    return (
      <Box>
        {completed === 0 && <EmptyStateNoPeople isHardSkill={isHardSkillSurvey} />}
        {campaignsForThisSurvey.length === 0 && completed > 0 && (
          <EmptyStateNoCampaigns setTrigger={setTrigger} countPeople={completed} />
        )}
        {campaignsForThisSurvey.length > 0 && (
          <CampaignsList setTrigger={setTrigger} trigger={trigger} />
        )}
      </Box>
    );
  }

  return null;
};
